import React from "react";

interface IconHeartProps {
  width?: number;
  height?: number;
  className?: string;
  filled?: boolean;
}

const IconHeart: React.FC<IconHeartProps> = ({
  width = 24,
  height = 24,
  className = "",
  filled = false,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill={filled ? "currentColor" : "none"}
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
  </svg>
);

export default IconHeart;
